exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-elements-button__button{border-radius:4px;border:none;display:flex;width:100%;padding:14px 0;height:45px;justify-content:center;align-items:center;gap:8px;cursor:pointer;font-family:Lato;font-size:14px;font-style:normal;font-weight:600;line-height:normal;letter-spacing:.14px;overflow:hidden}.nil-sa-elements-button__button:disabled{cursor:not-allowed;opacity:.5}.nil-sa-elements-button__button:disabled:hover{background-color:#d0532c}.nil-sa-elements-button__button.nil-sa-elements-button__theme_orange{background-color:#d0532c;color:#fff}.nil-sa-elements-button__button.nil-sa-elements-button__theme_orange:active,.nil-sa-elements-button__button.nil-sa-elements-button__theme_orange:hover{background-color:#ff7601}.nil-sa-elements-button__button.nil-sa-elements-button__theme_gray{background-color:#72879b;color:#fff}.nil-sa-elements-button__button.nil-sa-elements-button__theme_gray:active,.nil-sa-elements-button__button.nil-sa-elements-button__theme_gray:hover{background-color:#354b60}.nil-sa-elements-button__spinnerContainer{min-width:40px}.nil-sa-elements-button__spinner{margin:0 auto}", ""]);

// exports
exports.locals = {
	"button": "nil-sa-elements-button__button",
	"theme_orange": "nil-sa-elements-button__theme_orange",
	"theme_gray": "nil-sa-elements-button__theme_gray",
	"spinnerContainer": "nil-sa-elements-button__spinnerContainer",
	"spinner": "nil-sa-elements-button__spinner"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/elements/Button/index.less
// module id = 233
// module chunks = 0